module.exports = "/_next/static/images/44693b61e25cd626066a61639485eb61-hero-mobile.png";